<app-details-panel-shell
  *ngIf="entry"
  [visible]="visible"
  [showEditButton]="false"
  title=" "
  (onClose)="onClose.emit()"
>
  <app-gpd-button toolbarStart type="text" [text]="labelOpenContract" (onClick)="onOpenContract.emit()"></app-gpd-button>

  <div class="data-tab">
    <div class="header">
      <span>{{ labelDeadlineDetails }}</span>
    </div>
    <div class="sort">
      <div class="data-item">
        <span class="field-label">{{ labelDue }}</span>
        <span>{{ formatDueDate(entry.date) }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelDeadlineType }}</span>
        <span>{{ deadlineTypeLabel || '—' }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelAssignedTo }}</span>
        <span>{{ assigneeDisplayName || '—' }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelStatus }}</span>
        <app-status-pill [statusId]="deadlineStatusId" [statusConfig]="deadlineStatusConfig"></app-status-pill>
      </div>
    </div>
    <div class="data-item" *ngIf="deadline?.note">
      <span class="field-label">{{ labelNote }}</span>
      <p class="note-text">{{ deadline.note }}</p>
    </div>
  </div>

  <div class="data-tab">
    <div class="header">
      <span>{{ labelContractDetails }}</span>
    </div>
    <div class="sort">
      <div class="data-item">
        <span class="field-label">{{ labelContractName }}</span>
        <span>{{ entry.title }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelContractType }}</span>
        <span>{{ contractTypeLabel || '—' }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelIntern }}</span>
        <span>{{ deadline?.contractPartyIntern?.displayName || '—' }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelExtern }}</span>
        <span>{{ deadline?.contractPartyExtern?.displayName || '—' }}</span>
      </div>
      <div class="data-item" *ngIf="contract?.statusId">
        <span class="field-label">{{ labelStatus }}</span>
        <app-status-pill [statusId]="contract.statusId" [statusConfig]="contractStatusConfig"></app-status-pill>
      </div>
    </div>
    <div class="data-item" *ngIf="contract?.notes">
      <span class="field-label">{{ labelNote }}</span>
      <p class="note-text" [innerHTML]="contract.notes"></p>
    </div>
  </div>

  <div class="doc-tab" *ngIf="contract?.documents?.length">
    <div class="header">
      <span>{{ labelDocuments }}</span>
    </div>
    <div class="document-container">
      <app-contracts-pill
        *ngFor="let document of contract.documents"
        [content]="document"
        [linkType]="'document'"
        icon="doc"
      ></app-contracts-pill>
    </div>
  </div>

</app-details-panel-shell>
